import React, { useState, useEffect } from 'react';
import './dashboard.scss';

import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import DashboardHeader from '../../components/Header/DashboardHeader';
import DashboardFooter from '../../components/Footer/DashboardFooter';
import withFeatureFlags from '../../components/FeatureFlags/withFeatureFlags'
import SiteDown from '../../components/SiteDown/SiteDown';
import OutOfHours from '../../components/LiveChat/OutOfHours';
import ChatDownTime from '../../components/LiveChat/ChatDownTime';
import { joinClasses } from '../../utils/helpers';
import { useUnifiedAnalytics } from "../../contexts/AnalyticsWrapper";
import ContactUs from "../../components/ContactUs/ContactUs";

/** @import { DashboardProps } from './DashboardTypes' */
/** @import { Notification } from "../../components/Dashboard/Notifications/NotificationTypes" */

const DashboardLayout = (/** @type {DashboardProps} */ { children, notifications, className, featureEnabled, fullWidth = false }) => {
    const [notificationsArray, setNotifications] = useState(notifications.filter(x => !x.dismissed()));

    const removeNotification = (/** @type {Notification} */ notification) => {
        notification.markAsRead();
        notification.dismiss();
        setNotifications(notificationsArray.filter(n => n !== notification));
    };

    const analytics = useUnifiedAnalytics();

    useEffect(() => {
        if (analytics) {
            let fullPath = window.location.pathname; // Get the pathname
            let pathName = fullPath.split('/').pop();

            // Default to "dashboard" when path is empty
            if (!pathName) {
                pathName = "dashboard";
            }

            // Check if the path is for account details view
            if (fullPath.includes('/account-details/')) {
                pathName = "View your instruction";
            }

            analytics.trackAnalyticsPageEvent('generic load',{},'',`Investec-Save-secure|page_load|${pathName}`);
        }
    }, []);

    if (featureEnabled("DashboardOffline")) {
        return (
            <SiteDown />
        );
    }
    return (
        <div className={joinClasses('dashboard-layout', className || '')}>
            <div className='dashboard-content'>
                <Breadcrumbs withBg />
                <DashboardHeader notifications={notificationsArray} removeNotification={removeNotification} />
               <div className={fullWidth || (React.isValidElement(children) && children.type === ContactUs) ? '' : 'dashboard-layout__content'}>
                   {children}
               </div>
                <hr className="dashboard-layout__bottom-line" />
            </div>
            <DashboardFooter />
            <OutOfHours />
            <ChatDownTime />
        </div>
    );
};

export default withFeatureFlags(DashboardLayout);

